module.exports = __webpack_public_path__ + "static/img/img_cabinet.4064dec2.png";